export const isAppCompatibilityError = (error: unknown) => {
  if (typeof error !== 'object' || !error) return false;

  const status = 'status' in error && error.status === 400;
  const errorCode =
    'body' in error &&
    typeof error.body === 'object' &&
    error.body !== null &&
    'error_code' in error.body &&
    error.body.error_code === 'CLIENT_NOT_SUPPORTED';

  return status && errorCode;
};

export const isClientSideAppCompatibilityError = (error: unknown) => {
  if (typeof error !== 'object' || !error) return false;

  const isIncompatibleErrorMessage =
    'message' in error &&
    error.message === 'current client version is not supported';
  return isIncompatibleErrorMessage;
};
